var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInadequate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -445.2,
    y: 29.6,
    className: "st0",
    width: 256,
    height: 256
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -317.2,
    cy: 157.6,
    r: 118
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -361.5,
    cy: 133,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -272.9,
    cy: 133,
    r: 9.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-266.1,216.6c-16.4-28.2-52.6-37.8-80.8-21.5c-8.9,5.2-16.3,12.6-21.5,21.5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 128,
    cy: 128,
    r: 117.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71.1,176.1c9.5-22,31.4-37.4,56.9-37.4c25.5,0,47.4,15.4,56.9,37.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.3,99.7c2.5,4.4,7.2,7.3,12.6,7.3c5,0,9.5-2.6,12.1-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M193.7,99.7c-2.5,4.4-7.2,7.3-12.6,7.3c-5,0-9.5-2.6-12.1-6.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInadequate);
export default __webpack_public_path__ + "static/media/Inadequate.1feaf650a5534589f7a7682bd3a289bc.svg";
export { ForwardRef as ReactComponent };